import { render, staticRenderFns } from "./related_articles_block.vue?vue&type=template&id=6ba4c815&lang=pug"
import script from "./related_articles_block.vue?vue&type=script&lang=js"
export * from "./related_articles_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports